import { SETTINGS_GROUPS } from '@ekhodealer/ekho-common';

import type { Section, SettingsGroup } from '@ekhodealer/ekho-common';

/**
 * Get the SettingsGroup for a given section based on its prefix
 */
export function getSectionGroup(section: Section): SettingsGroup | null {
	if (section.startsWith('PROGRAM_')) {
		return SETTINGS_GROUPS.PROGRAM;
	}
	if (section.startsWith('DOMAINS_')) {
		return SETTINGS_GROUPS.DOMAINS;
	}
	if (section.startsWith('INTERNAL_')) {
		return SETTINGS_GROUPS.INTERNAL;
	}
	if (section.startsWith('OPERATIONS_')) {
		return SETTINGS_GROUPS.OPERATIONS;
	}
	if (section.startsWith('INVENTORY_')) {
		return SETTINGS_GROUPS.INVENTORY;
	}
	return null;
}

/**
 * Group titles mapped by SettingsGroup
 */
export const GROUP_TITLES: Record<SettingsGroup, string> = {
	[SETTINGS_GROUPS.PROGRAM]: 'Program settings',
	[SETTINGS_GROUPS.DOMAINS]: 'Website',
	[SETTINGS_GROUPS.INVENTORY]: 'Inventory',
	[SETTINGS_GROUPS.OPERATIONS]: 'Operations',
	[SETTINGS_GROUPS.INTERNAL]: 'Internal',
};
